<script>
  import BlueChip from "./base/BlueChip.svelte";
</script>

<BlueChip title={"計画担当者"} />
